export const Emoji = [
    {
        id: 1,
        source: 'https://fonts.gstatic.com/s/e/notoemoji/latest/1f60e/512.webp',
        img: 'https://fonts.gstatic.com/s/e/notoemoji/latest/1f60e/512.gif'
    },
    {
        id: 2,
        source: 'https://fonts.gstatic.com/s/e/notoemoji/latest/1f607/512.webp',
        img: 'https://fonts.gstatic.com/s/e/notoemoji/latest/1f607/512.gif'
    },
    {
        id: 3,
        source: 'https://fonts.gstatic.com/s/e/notoemoji/latest/1f622/512.webp?1',
        img: 'https://fonts.gstatic.com/s/e/notoemoji/latest/1f622/512.gif?1'
    },
    {
        id: 4,
        source: 'https://fonts.gstatic.com/s/e/notoemoji/latest/1f483_1f3fd/512.webp',
        img: 'https://fonts.gstatic.com/s/e/notoemoji/latest/1f483_1f3fd/512.gif'
    },
    {
        id: 5,
        source: 'https://fonts.gstatic.com/s/e/notoemoji/latest/1f4a5/512.webp',
        img: 'https://fonts.gstatic.com/s/e/notoemoji/latest/1f4a5/512.gif'
    },
    {
        id: 6,
        source: 'https://fonts.gstatic.com/s/e/notoemoji/latest/1f440/512.webp',
        img: 'https://fonts.gstatic.com/s/e/notoemoji/latest/1f440/512.gif'
    },
    {
        id: 7,
        source: 'https://fonts.gstatic.com/s/e/notoemoji/latest/1f44c/512.webp',
        img: 'https://fonts.gstatic.com/s/e/notoemoji/latest/1f44c/512.gif'
    },
    {
        id: 8,
        source: 'https://fonts.gstatic.com/s/e/notoemoji/latest/1f32a_fe0f/512.webp',
        img: 'https://fonts.gstatic.com/s/e/notoemoji/latest/1f32a_fe0f/512.gif'
    },
    {
        id: 9,
        source: 'https://fonts.gstatic.com/s/e/notoemoji/latest/1f40d/512.webp',
        img: 'https://fonts.gstatic.com/s/e/notoemoji/latest/1f40d/512.gif'
    },
    {
        id: 10,
        source: 'https://fonts.gstatic.com/s/e/notoemoji/latest/1faa4/512.webp',
        img: 'https://fonts.gstatic.com/s/e/notoemoji/latest/1faa4/512.gif'
    },
    {
        id: 11,
        source: 'https://fonts.gstatic.com/s/e/notoemoji/latest/2753/512.webp',
        img: 'https://fonts.gstatic.com/s/e/notoemoji/latest/2753/512.gif'
    },
    {
        id: 12,
        source: 'https://fonts.gstatic.com/s/e/notoemoji/latest/1f61e/512.webp',
        img: 'https://fonts.gstatic.com/s/e/notoemoji/latest/1f61e/512.gif'
    },
    {
        id: 13,
        source: 'https://fonts.gstatic.com/s/e/notoemoji/latest/1f9a0/512.webp',
        img: 'https://fonts.gstatic.com/s/e/notoemoji/latest/1f9a0/512.gif'
    },
    {
        id: 14,
        source: 'https://fonts.gstatic.com/s/e/notoemoji/latest/1f485/512.webp',
        img: 'https://fonts.gstatic.com/s/e/notoemoji/latest/1f485/512.gif'
    },
    {
        id: 15,
        source: 'https://fonts.gstatic.com/s/e/notoemoji/latest/1f35c/512.webp',
        img: 'https://fonts.gstatic.com/s/e/notoemoji/latest/1f35c/512.gif'
    },
    {
        id: 16,
        source: 'https://fonts.gstatic.com/s/e/notoemoji/latest/1f697/512.webp',
        img: 'https://fonts.gstatic.com/s/e/notoemoji/latest/1f697/512.gif'
    },
    {
        id: 17,
        source: 'https://fonts.gstatic.com/s/e/notoemoji/latest/1f3d5_fe0f/512.webp',
        img: 'https://fonts.gstatic.com/s/e/notoemoji/latest/1f3d5_fe0f/512.gif'
    },
    {
        id: 18,
        source: 'https://fonts.gstatic.com/s/e/notoemoji/latest/2764_fe0f/512.webp',
        img: 'https://fonts.gstatic.com/s/e/notoemoji/latest/2764_fe0f/512.gif'
    }
]
